export const SocialData=[
    
    {
        platform:"Github",
        icon: require("../../assets/icons/github.png"),
        link:"https://github.com/muhammadidreeskhan",
    },
    {
        platform:"Linkedin",
        icon: require("../../assets/icons/linkedin.png"),
        link:"https://www.linkedin.com/in/muhammad-idrees-khan-796558117/",
    },
    {
        platform:"Twitter",
        icon: require("../../assets/icons/twitter.png"),
        link: "https://x.com/happyikhan",
    },
    {
        platform:"Facebook",
        icon: require("../../assets/icons/facebook.png"),
        link:"https://facebook.com/ikhan99",
    },
];